import React, { FC, useEffect } from 'react';
import { Layout } from 'antd';
import { WebUxSider } from './webux-layouts/WebUxSider';
import { WebUxFooter, WebUxHeader } from './webux-layouts/WebUxHeader';
import { WebUxContent } from './webux-layouts/WebUxContent';
import { SessionExpiryBanner } from './webux-layouts/SessionExpiryBanner';
import { useConnection, useUserInfo } from '../../connection/Application';
import { useHistory } from 'react-router-dom';
import { PageLoading } from '@ant-design/pro-layout';

// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {};
export const WebUx: FC<Props> = () => {
  const user = useUserInfo();
  const connection = useConnection();
  const history = useHistory();
  // The session is restored from the server (HttpOnly cookie); wait for that check before
  // deciding the user is signed out.
  const sessionLoading = connection.isSessionLoading();
  useEffect(() => {
    if (!user && !sessionLoading) {
      history.replace('/login');
    }
  }, [history, user, sessionLoading]);
  if (!user) {
    return <PageLoading />;
  }
  return (
    <Layout>
      <WebUxSider />
      <Layout style={{ position: 'relative' }}>
        <SessionExpiryBanner />
        <WebUxHeader />
        <WebUxContent />
        <WebUxFooter />
      </Layout>
    </Layout>
  );
};
